/**
 * Project panel
 *
 * Created by stefensuhat on 26/07/18 11.57 AM
 */

import { Button, CircularProgress, Snackbar as SB, withStyles } from '@material-ui/core';
import { amber, green } from '@material-ui/core/colors';
import Icon from '@material-ui/core/Icon';
import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

const mapStateToProps = ({ snackbar }) => ({
    payload: snackbar.content,
});

const mapDispatch = dispatch => ({
    remove: () => dispatch.snackbar.remove,
});

const reduxConnector = connect(mapStateToProps, mapDispatch);
// const variantIcon = {
//     success: CheckCircleIcon,
//     warning: WarningIcon,
//     error: ErrorIcon,
//     info: InfoIcon,
// };
const styles = theme => ({
    loading: {
        color: theme.palette.secondary.dark,
    },
    span: {
        display: 'flex',
        alignItems: 'center',
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

const defaultState = {
    open: false,
    payload: {},
    messageInfo: {},
};

class Snackbar extends Component {
    queue = [];

    static propTypes = {};

    static defaultProps = {};

    state = defaultState;


    componentDidUpdate(prevProps, prevState) {
        const { payload, open } = this.state;

        if (prevState.payload !== payload && !isEmpty(payload)) {
            const {
                message, loading, type, action,
            } = payload;
            const autoHideDuration = loading ? null : 5000;

            this.queue.push({
                message,
                type,
                autoHideDuration,
                loading,
                action,
                key: new Date().getTime(),
            });

            if (open) {
                // immediately begin dismissing current message
                // to start showing new one
                this.setState({ open: false });
            } else {
                this.processQueue();
            }
        }
    }

    static getDerivedStateFromProps(props) {
        if (props.payload) {
            return { payload: props.payload };
        }

        return defaultState;
    }

    removeSnackbar = () => {
        this.setState({ open: false });
    };

    processQueue = () => {
        const { remove } = this.props;

        if (this.queue.length > 0) {
            this.setState({
                messageInfo: this.queue.shift(),
                open: true,
            });

            return null;
        }

        this.setState({ open: false });
        remove();

        return null;
    };

    handleExited = () => {
        this.processQueue();
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.removeSnackbar();
    };

    render() {
        const { messageInfo, open } = this.state;
        const {
            message, autoHideDuration, loading, key, action,
        } = messageInfo;
        const { classes } = this.props;

        return (
            <SB
                key={key || Math.random()}
                open={open}
                autoHideDuration={autoHideDuration}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                onClose={this.handleClose}
                onExited={this.handleExited}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={(
                    <Fragment>
                        <span id="message-id" className={classes.message}>
                            <Icon className={clsx(classes.icon, classes.iconVariant)} />
                            {message}
                        </span>
                    </Fragment>
                )}
                action={[
                    loading && (
                        <CircularProgress
                            size={20}
                            color="secondary"
                            thickness={6}
                        />
                    ), action && (
                        <Button color="secondary" onClick={action.onActionClick}>
                            {action.message}
                        </Button>
                    ),
                ]}
            />
        );
    }
}

export default compose(
    withStyles(styles, { name: 'Snackbar' }),
    reduxConnector,
)(Snackbar);
